import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Loader from "../../components/Loader";
import { displayToast } from "../../components/app/AppToast";
import { useQRCodeScanner } from "../../domains/room/hooks/useQRCodeScanner";
import { isAndroidApp } from "../../tools/android";
import { isIOSApp } from "../../tools/ios";
import { useTranslation } from "react-i18next";

export default function SignupQRCodePage() {
  const { t } = useTranslation();
  const history = useHistory();
  const { isError } = useQRCodeScanner(true);

  useEffect(() => {
    if (!isIOSApp() && !isAndroidApp()) {
      history.push("/login");
      displayToast(t("Something went wrong. Please try again."), "error");
    }
  }, []);

  // When scan is cancelled or fails, just return to the previous screen
  // (LoginSheet / SignupPage) — the hook already shows a toast for real errors.
  useEffect(() => {
    if (isError) history.goBack();
  }, [isError, history]);

  // Prevent flash of QR scanner UI on web before redirect
  if (!isIOSApp() && !isAndroidApp()) return null;

  return <Loader expanded />;
}
